<a (click)="onClick($event)" [title]="title">
  <i
    *ngIf="icon"
    [ngClass]="icon"
    [class.highlight]="highlight"
    [class.disabled]="disabled"
    class="fa"
    aria-hidden="true"
  >
  </i>
  <img
    *ngIf="imageIcon"
    [src]="imageIcon"
    [class.highlight]="highlight"
    [class.disabled]="disabled"
    alt="title"
  />
</a>
